export default {
  data: {
    result: '过敏',
    propose: '这个是测试结果'
  }
}
